
angular
    .module('meevo.plugins.drawerManager')
    .filter('nonCashTransactions', [
        function () {
            return function (transactions) {
                var filtered = _.filter(transactions, function (t: any) { return (t.paymentCategory != Meevo.Model.PaymentCategoryEnum.Cash); });
                return filtered;
            };
        }
    ])
    .filter('onlyCashTransactions', [
        function () {
            return function (transactions) {
                var filtered = _.filter(transactions, function (t: any) { return (t.paymentCategory == Meevo.Model.PaymentCategoryEnum.Cash); });
                return filtered;
            };
        }
    ])
    .filter('sumOnField', [
        function () {
            return function (transactions, fieldName) {
                var total = 0;
                _.each(transactions, function (item, ndx, arr) { if (_.isNumber(item[fieldName])) { total += item[fieldName]; } });
                return total;
            };
        }
    ])
    .filter('drawerManagerDate', [ '$filter',
        function ($filter) {
            return function (value) {
                return $filter('date')(value, 'EEE M/d/yy h:mm a');
            }
        }
    ])
;
